import React from "react";
import { TECH_STACK } from "../../data/site";

export default function TechStack({ SectionHeader }) {
  return (
    <section id="stack" className="relative py-24 md:py-32 px-6 md:px-10 border-t border-slate-800/50">
      <div className="max-w-[1400px] mx-auto">
        <SectionHeader
          index="07"
          kicker="Tooling & Platforms"
          title="Opinionated on quality, not on vendor."
          description="Reference tooling used across engagements. Every element is chosen for auditability, upstream governance, and cost profile suitable for public sector budgets."
        />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 reveal">
          {TECH_STACK.map((g) => (
            <div key={g.group} className="panel hover-lift p-6">
              <div className="flex items-center justify-between mb-5">
                <div className="eyebrow">{g.group}</div>
                <span className="font-mono text-[10px] text-slate-500">{String(g.items.length).padStart(2, "0")} items</span>
              </div>
              <div className="flex flex-wrap gap-2">
                {g.items.map((it) => (
                  <span
                    key={it}
                    className="font-mono text-[11px] tracking-tight text-slate-200 border border-slate-800 hover:border-cyan-400/50 hover:text-cyan-200 transition-colors px-2.5 py-1.5"
                  >
                    {it}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
